<template lang="pug">
div
  SubHeader(apiname='faq',headname='FAQ')
  .card
    .container-fluid
      h3.box-title FAQ一覧
      List(apiname='faq',editPath='edit')
      router-link(to='edit')
        el-button.col-md-12(type='primary', icon='el-icon-edit') 新規登録
</template>

<script>
import SubHeader from '@/views/components/swan/common/SubHeader'
import List from '@/views/components/swan/common/List'

export default {
  name: 'FaqTop',
  data () {
    return {}
  },
  components: {
    SubHeader,
    List
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/faq/list.vue